import { useEffect } from "react";

const SITE = "Sadguru Narayan Swami Math, Audumbar";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} | Shri Datta Kshetra Seva Trust`;
    document.title = full;
    setMeta("description", description);
    setMeta("og:title", full, "property");
    setMeta("og:description", description, "property");
  }, [title, description]);
  return null;
}
